import React, { useState } from "react";
import { Modal } from "antd";
import DashBoardGmaps from "../DashBoard/DashBoardGmaps";
import styles from "../DashBoard/DashBoard.module.scss";
import { ITripDetails } from "../ServiceUsers/Interfaces/ITripDetails";

type Props = {
  trip: ITripDetails;
  layoutWidth?: string;
  layoutHeight?: string;
  modalWidth?: string;
  modalHeight?: string;
};
const GMapsModal: React.FC<Props> = ({
  trip,
  layoutWidth,
  layoutHeight,
  modalWidth,
  modalHeight,
}) => {
  const [isMapModalOpen, setIsMapModalOpen] = useState<boolean>(false);

  return (
    <>
      <DashBoardGmaps
        setIsMapModalOpen={setIsMapModalOpen}
        tripDetails={trip}
        width={layoutWidth}
        height={layoutHeight}
      />

      <Modal
        visible={isMapModalOpen}
        footer={null}
        className={`${styles.fullScreenMap} ${styles.fullScreenMapModal}`}
      >
        <DashBoardGmaps
          isMapModalOpen={isMapModalOpen}
          setIsMapModalOpen={setIsMapModalOpen}
          tripDetails={trip}
          width={modalWidth}
          height={modalHeight}
        />
      </Modal>
    </>
  );
};

export default GMapsModal;
